import { API_URL, GETAPI } from "./config";

export const GET_VALUES = async () => {
  const res = await GETAPI(API_URL.getValues);
  return res;
};
